import LoanProductPage from '@/pages/loan/components/LoanProductPage';

export default function PersonalPage() {
  return <LoanProductPage slug="personal" />;
}